module.exports = __webpack_public_path__ + "img/why-1.84884ef3.svg";